/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Omit<Company, \'id\'>, schemaOptions: { title: \'NewCompany\', exclude: [ \'id\' ] })
 */
export interface NewCompany { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    /**
     * The name company
     */
    name: string;
    description?: string;
    color?: string;
    code?: string;
    logoUrl?: string;
    reportByBu?: boolean;
}

